import React, { Component } from 'react';

export class ScanPutawayCart extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.focusInput('putawayCart');
    }

    render() {
        return (
            <div>
                <div className="scan-field">
                    <h3>Scan a Putaway Cart</h3>
                    <input type="text" id="putawayCart" onBlur={() => { this.props.focusInput('putawayCart') }} value={this.props.putawayCart} onChange={(e) => { this.props.updateInputValue(e) }} />
                </div>
            </div>
        );
    }
}